import React from "react";
import ReactPaginate from "react-paginate";

const Paginations = ({
  currentPage = 1,
  onPageChange,
  lastPage = 1,
  fixedPerPage = null,
  totalItems,
  perItem,
  itemsPerPage,
  perPageOptions = null,
}) => {
  const handleCallback = (page) => {
    onPageChange(page.selected + 1);
  };

  const renderPerPageSelect = () => {
    if (fixedPerPage && fixedPerPage !== 5) {
      return (
        <select className="cms-pagination__select" defaultValue={fixedPerPage} disabled>
          <option value={fixedPerPage}>{fixedPerPage}</option>
        </select>
      );
    }

    const options =
      perPageOptions ||
      (fixedPerPage === 5
        ? ["5", "10", "25", "100", "200"]
        : ["10", "25", "100", "200"]);

    const allValue = totalItems > 0 ? totalItems : "all";
    const selectValue =
      itemsPerPage >= totalItems && totalItems > 0 ? allValue : itemsPerPage;

    return (
      <select
        value={selectValue}
        onChange={(event) => onPageChange(currentPage, event.target.value)}
        className="cms-pagination__select"
      >
        {options.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
        {totalItems > 0 ? (
          <option value={totalItems}>All</option>
        ) : null}
      </select>
    );
  };

  return (
    <div className="cms-pagination col-12">
      <div className="cms-pagination__bar">
        <div className="cms-pagination__per-page">
          <label className="cms-pagination__label">
            <span className="cms-pagination__label-text">Rows</span>
            {renderPerPageSelect()}
          </label>
        </div>

        <p className="cms-pagination__info">
          Page <strong>{currentPage}</strong> · Showing{" "}
          <strong>{perItem}</strong> of <strong>{totalItems}</strong> entries
        </p>

        <div className="cms-pagination__controls">
          <ReactPaginate
            breakLabel="…"
            nextLabel="Next"
            onPageChange={handleCallback}
            pageRangeDisplayed={3}
            pageCount={lastPage}
            marginPagesDisplayed={2}
            previousLabel="Prev"
            renderOnZeroPageCount={null}
            containerClassName="cms-pagination__nav"
            pageClassName="cms-pagination__item"
            pageLinkClassName="cms-pagination__link"
            previousClassName="cms-pagination__item cms-pagination__item--nav"
            previousLinkClassName="cms-pagination__link cms-pagination__link--nav"
            nextClassName="cms-pagination__item cms-pagination__item--nav"
            nextLinkClassName="cms-pagination__link cms-pagination__link--nav"
            breakClassName="cms-pagination__item cms-pagination__item--break"
            breakLinkClassName="cms-pagination__link cms-pagination__link--break"
            activeClassName="cms-pagination__item--active"
            disabledClassName="cms-pagination__item--disabled"
            forcePage={currentPage - 1}
          />
        </div>
      </div>
    </div>
  );
};

export default Paginations;
